<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-form ref="form" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-card color="kbWhite">
          <v-card-title>
            <h4 class="kbDarkBlueText--text text-capitalize ml-2">{{$t('general.newApplication')}}</h4>
          </v-card-title>

          <v-card-text>
            <v-col cols="12" class="subtitle kbDarkBlueText--text pt-4" >
                {{$t('general.creatingANewApplicationIsVerySimpleJustFillInTheInformationWeRequestToGoToTheNextStep')}}
            </v-col>

            <v-col class="pt-4" cols="12" >
              <v-text-field :label="$t('general.applicationName')"
                            color="kbDarkBlueText"
                            v-model="nameApp"
                            :rules="[rules.required]"
                            @blur="computePrefix(nameApp)">
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field v-model="baseUrl"
                            color="kbDarkBlueText"
                            :label="$t('general.baseUrl')"
                            :rules="[rules.required, rules.url]"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field :label="$t('general.prefix')"
                            color="kbDarkBlueText"
                            v-model="appPrefix"
                            v-uppercase maxlength="3"></v-text-field>
            </v-col>

            <v-col class="pt-4" cols="12" >
              <v-autocomplete :label="$t('general.business')"
                        color="kbDarkBlueText"
                        v-model="companyUuid"
                        :rules="[rules.required]"
                        :items="companies"
                        item-text="name"
                        item-value="UUID">
                <template v-slot:prepend-item>
                  <v-list-item @click="goto('/companies/new')">
                    <v-list-item-avatar color="kbDarkBlueText">
                      <v-icon dark>business</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="kbDarkBlueText--text">Crear un nuevo negocio</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-col>

            <v-card-actions>
              <v-btn block
                     color="kbBlue"
                     dark
                     @click="submit"
                     :loading="creatingApp">
                  {{$t('general.addNewApplication')}}
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import directives from '@/libs/global_directives'
import rules from '@/libs/rules'
export default {
  directives: {
    uppercase: directives.uppercase
  },
  computed: {
    ...mapState({
      loadingCompanies: state => state.companies.loadingCompanies,
      companies: state => state.companies.companies
    })
  },
  created () {
    this.$store.dispatch('getCompanies')
  },
  data () {
    return {
      creatingApp: false,
      companyUuid: '',
      nameApp: '',
      baseUrl: '',
      appPrefix: '',
      rules: rules
    }
  },
  methods: {
    async submit () {
      try {
        if (!this.$refs.form.validate()) return

        const data = {
          companyUuid: this.companyUuid,
          nameApp: this.nameApp,
          prefix: this.appPrefix,
          baseUrl: this.baseUrl
        }

        this.creatingApp = true
        const response = await this.$store.dispatch('createApp', data)

        if (!response.success) {
          this.creatingApp = false
          return notifications.error(response.message)
        }

        const appUUID = response.app.UUID
        notifications.success(this.$t('general.applicationSuccessfullyCreated'))

        const info = {
          extradata: [
            {
              access: 'public',
              field: 'chat',
              value: {
                authMethod: 'none',
                customFormTitle: '',
                customizedQuestions: [],
                enableInactivity: false,
                finishOptions: [],
                formFields: [],
                inactivityMessage: '',
                inactivitySeconds: 30,
                language: 'es',
                logo: '',
                mainColor: '#3b3b3b',
                permanentMessages: [],
                position: 'right',
                quickResponses: [],
                timeZone: {
                  label: 'America/Bogota',
                  offset: '−05:00'
                },
                urlBase: '',
                workingHours: {
                  blockMessageComposer: false,
                  days: [
                    { code: 0, isClosed: false, schedules: [] },
                    { code: 1, isClosed: false, schedules: [] },
                    { code: 2, isClosed: false, schedules: [] },
                    { code: 3, isClosed: false, schedules: [] },
                    { code: 4, isClosed: false, schedules: [] },
                    { code: 5, isClosed: false, schedules: [] },
                    { code: 6, isClosed: false, schedules: [] }
                  ],
                  enable: false,
                  message: ''
                },
                showEmojis: false,
                automaticallyAssignAdvisorsWaitingForConversations: false,
                theme: 'light',
                title: ''
              }
            }
          ]
        }

        await this.$store.dispatch('updateApp', { companyId: this.companyUuid, appId: appUUID, data: info })

        this.creatingApp = false

        const company = await this.$store.dispatch('getCompany', this.companyUuid)

        if (!company) {
          this.creatingApp = false
          return notifications.error(this.$t('general.errorTryAgain'))
        }

        this.creatingApp = false
        await this.$store.dispatch('getApp', { appId: appUUID, getStatistics: false })
        await this.$router.push(`/companies/${this.companyUuid}/apps/${appUUID}`)
      } catch (e) {
        console.error(e)
        this.creatingApp = false
      }
    },
    goto (route) {
      this.$router.push(route)
    },
    computePrefix (appName) {
      // get word count
      appName = appName.trim()
      const words = appName.split(' ')
      const wordCount = words.length
      let prefix = ''
      if (wordCount === 1) {
        // 3 first words
        prefix = words[0].substring(0, 3)
      } else if (wordCount === 2) {
        // first 2 second 1
        prefix = `${words[0].substring(0, 2)}${words[1].substring(0, 1)}`
      } else if (wordCount > 2) {
        // get acronym of fisrt three words
        prefix = `${words[0].substring(0, 1)}${words[1].substring(0, 1)}${words[2].substring(0, 1)}`
      }
      if (prefix.length !== 3) {
        prefix = words[0].substring(0, 3)
      }
      // to uppercase
      prefix = prefix.toUpperCase()
      this.appPrefix = prefix
    }
  }
}
</script>
